import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "app";

const initialState = {
    isMenuOpen: false,
};

export const sectionPlaneSlice = createSlice({
    name: "sectionPlane",
    initialState,
    reducers: {
        setMenuOpen: (state, action: PayloadAction<boolean>) => {
            state.isMenuOpen = action.payload;
        },
    },
});

export const selectIsSectionMenuOpen = (state: RootState) => state.sectionPlane.isMenuOpen;

const { actions, reducer } = sectionPlaneSlice;
export { actions as sectionPlaneActions, reducer as sectionPlaneReducer };
